import { render } from "./disabled-app.vue?vue&type=template&id=3c36d294&ts=true"
import script from "./disabled-app.vue?vue&type=script&lang=ts"
export * from "./disabled-app.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./disabled-app.vue?vue&type=style&index=0&id=3c36d294&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/workspace/ops/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.2.47_vue@3.2.47_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__